export enum MotivationCardTab {
    SALESRANK_MONTHLY,
    SALESRANK_QUARTERLY,
}
